import {createSymbol} from './createSymbol';
import {KeyboardSymbolKind} from 'ui/keyboard';

export const commaSymbol = createSymbol(KeyboardSymbolKind.Comma);
export const enterSymbol = createSymbol(KeyboardSymbolKind.Enter);
export const clearSymbol = createSymbol(KeyboardSymbolKind.Clear);
export const backspaceSymbol = createSymbol(KeyboardSymbolKind.Backspace);
export const toggleSymbol = createSymbol(KeyboardSymbolKind.ModeToggle);
